export const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Wine Club', path: '/wine-club' },
    { name: 'Menu', path: '/menu' },
    { name: 'Events and Tastings', path: '/events' },
    { name: 'Wine List', path: '/wine-list' },
    { name: 'Collectibles', path: '/collectible-wine' },
    { name: 'Contact Us', path: '/contact-us' },
  ];